"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  padding: 7px;\n  border: 1px solid #f0f0f0;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 5px;\n\n  .avatar-and-retailer {\n    display: flex;\n    align-items: center;\n    .retailer-name {\n      font-family: ", ";\n      font-size: 12px;\n      color: #262626;\n    }\n\n    > * + * {\n      margin-left: 10px;\n    }\n  }\n\n  .services-icons {\n    display: flex;\n\n    span {\n      color: #f0f0f0;\n      font-size: 14px;\n      &.is-active {\n        color: #8a6caa;\n      }\n    }\n\n    > * + * {\n      margin-left: 9px;\n    }\n  }\n"])), _variables.FontFamily.Lato);

exports.Container = Container;